import { IconBaseProps } from "react-icons";

export function WhitepaperIcon(props: IconBaseProps) {
  const { size = 24, color = "currentColor", ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16.5 20.385L14.5575 18.4425L13.5 19.5L16.5 22.5L22.5 16.5L21.4425 15.4425L16.5 20.385ZM6.75 12.75H12V14.25H6.75V12.75ZM6.75 9H15.75V10.5H6.75V9ZM6.75 5.25H15.75V6.75H6.75V5.25Z"
        fill={color}
      />
      <path
        d="M12 22.5H4.5C3.67275 22.5 3 21.8272 3 21V3C3 2.17275 3.67275 1.5 4.5 1.5H18C18.8273 1.5 19.5 2.17275 19.5 3V14.25H18V3H4.5V21H12V22.5Z"
        fill={color}
      />
    </svg>
  );
}
